<template>
  <div class="page">

    <div class="intro-block">
      <div class="bg-left"></div>
      <a class="product-pack"  target="_blank"  href="http://espumisan.ru/instructions/espumizan-extra/index.phtml?utm_source=Afisha&utm_medium=Branding&utm_campaign=Espumisan_adults_2018"
         @click="$ga.event('Ссылки', 'Продукт в шапк, внутр', 1)">
        <img src="../assets/img/pack.png" alt=""></a>
      <div class="bg-right"></div>
      <div class="afishaLink">
        <a @click="$ga.event('Ссылка', 'Афиша', 1)" href="https://www.afisha.ru/"  target="_blank"><span class="afisha"></span></a>
      </div>
      <div class="shareBlock" v-if="$resize && $mq.above(768)">
        <share-block></share-block>
      </div>
      <div class="container flex-b-center">
        <div class="photo" data-aos="fade-right">
          <img src="../assets/img/maria/intro.png" alt="">
        </div>
        <div class="info" data-aos="fade-left">
          <router-link to="/" class="back">назад</router-link>
          <h1 class="name">Мария,</h1>
          <h4 class="age">28 лет</h4>
          <div class="line"></div>
          <div class="sub-text">
            Мария и Саша только что поженились и отправляются в свадебное путешествие в Париж. Машина мечта! В такси до
            аэропорта девушка вспоминает, что забыла дома любимый пленочный фотоаппарат.
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="image-container" data-aos="fade-up">
        <img src="../assets/img/maria/content.jpg" alt="">
      </div>

      <div class="quote" data-aos="flip-left">
        <div class="line"></div>
        <div class="text"> Как же так? Снимки на телефон она категорически не признает для путешествий. Что делать? Попросить таксиста вернуться до дома? Время еще есть…
        </div>
        <div class="line"></div>
      </div>
      <question :data="this.question1"@correct="q1=true"  data-aos="fade-left"/>
      <Product data-aos="zoom-in"></Product>
      <div v-if="q1">
      <div class="content-block" data-aos="fade-up">
        <div class="content-block-image">
          <img src="../assets/img/maria/content2.jpg" alt="">
        </div>
        <div class="content-block-text">
          Саша — человек деловой. Молодожены уже сидят около гейта, но тут мужу начинают звонить по работе. Телефон плохо ловит,
          и он решает отойти подальше. Маша замечает в его сумке загадочную коробку, которую раньше не видела. Что это, интересно… Открыть или нет?
        </div>
      </div>
      <question :data="this.question2" @correct="q2=true"  data-aos="fade-right"/></div>
      <div v-if="q2">
      <p>Самолет должен идти на посадку, просят всех занять свои места. </p>
      <div class="quote" data-aos="flip-left">
        <div class="line"></div>
        <div class="text">Из-за перепадов давления у Марии началось ужасное вздутие живота. Она просит стюардессу пустить ее в туалет,
          но бортпроводница запрещает.
        </div>
        <div class="line"></div>
      </div>
        <question :data="this.question3" @correct="q3=true"  data-aos="fade-left"/></div>
      <div v-if="q3">
        <ReadMore data-aos="fade-up" :persons="['svetlana','elena']"/></div>


    </div>
    <WarningBlock/>
    </div>

</template>

<script>
import "../assets/scss/page.scss";
import ShareBlock from "@/components/ShareBlock.vue";
import Question from "../components/Question";
import Product from "../components/Product";
import ReadMore from "../components/ReadMore";
import WarningBlock from "../components/WarningBlock";
export default {
  name: "Elena",
  mounted() {
    document.body.classList.remove("modal-open");
      this.$ga.event(
          "Страница",
          `Мария`,
          1
      );
  },
  components: {
    ShareBlock,
    Question,
    Product,
    ReadMore,
    WarningBlock
  },
  data() {
    return {
      q1: false,
      q2: false,
      q3: false,
      question1: {
        image: require("../assets/img/maria/q1.png"),
        n: 1,
        css: "maria",
        reversed: false,
        title: "Что делать?",
        variants: [
          {
            title: "1. Да!",
            text: "Иначе всю поездку будешь сожалеть!",
            correct: false
          },
          {
            title: "2. Не надо!",
            text: "Дорога в аэропорт — явление непредсказуемое. ",
            correct: true
          }
        ],
        wrong: {
          title: "Фотоаппарат забрали,",

          text:
            "только на пути в аэропорт из-за аварии возникла жуткая пробка. На самолет парочка опоздала. "
        },
        correct: {
          text:
            "В аэропорт приехали вовремя. А пленочный фотоаппарат станет отличным поводом заглянуть в какую-нибудь парижскую комиссионку"
        }
      },
      question2: {
        n: 2,

        image: require("../assets/img/maria/q2.png"),
        css: "maria",
        reversed: true,
        title: "Как поступить?",
        variants: [
          {
            title: "1. Лазить по чужим вещам — неприлично!",
            text:
              "Этому учат еще в школе. Не стоит с этого начинать совместную жизнь. ",
            correct: true
          },
          {
            title: "2. У супругов тайн быть не должно",
            text: "Открывай!",
            correct: false
          }
        ],
        wrong: {
          title: "Саша вернулся в момент, когда Маша лезла в его сумку.",
          text:
            "Муж рассердился и обиделся на Машу, что та без спросу лезет \n" +
            "в его вещи. Казалось бы, мелочь, но настроение было испорчено\n" +
            "на все путешествие."
        },
        correct: {
          text:
            "Саша вернулся, и пара села в самолет. Тут новоиспеченный супруг достал из сумки ту самую коробку — это оказался новый \n" +
            "пленочный фотоаппарат. Редкая модель, которую Маша долго пыталась найти в интернете. Ну и подарок!"
        }
      },
      question3: {
        n: 3,

        image: require("../assets/img/maria/q3.png"),
        css: "maria",
        reversed: false,
        title: "Что делать?",
        variants: [
          {
            title: "1. Устроить скандал",
            text:
              "В смысле — не пускают в туалет? Ты взрослый человек! И не забудь про жалобную книгу. \n",
            correct: false
          },
          {
            title: "2. Рассказать стюардессе о недомогании",
            text: "Наверняка она что-то придумает.",
            correct: true
          }
        ],
        wrong: {
          title:
            "Скандал обернулся тем, что Машу повели в отделение полиции в аэропорту Парижа. Вздутие живота закончилось статьей за хулиганство и гигантским штрафом. ",
          text: ""
        },
        correct: {
          text:
            " Стюардесса сказала, что это обычное дело: принесла воды и необходимое лекарство. Встречай, Париж! ",
          style: {
            fontSize: "40px"
          }
        }
      }
    };
  }
};
</script>

<style scoped lang="scss">
  .product-pack{
    left: 3vw;
    top: 18vh;
  }
.bg-left {
  position: absolute;
  left: 0;

  top: 0;
  background: url("../assets/img/maria/bg-left.png");
  height: 100%;
  width: 40%;
  background-repeat: no-repeat;
  z-index: -1;
  background-size: contain;
}

.bg-right {
  position: absolute;
  right: 0;
  top: 0;
  background: url("../assets/img/maria/bg-right.png");
  height: 100%;
  width: 40%;
  background-repeat: no-repeat;
  z-index: -1;
  background-size: contain;
  background-position: top right;
}

.info {
  background-image: url("../assets/img/maria/3.png");
  padding-bottom: 40px;
}

.content-block {
  justify-content: space-between;
  .content-block-text {
    line-height: 24px;
    font-size: 17px;
  }
}

@media screen and (max-width: 768px) {
  .bg-left {
    background-image: url("../assets/img/maria/bg-left-mobile.png");
  }
  .bg-right {
    background-image: url("../assets/img/maria/bg-right-mobile.png");
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Maria.vue